/**
 * Company: SPHMedia
 * Description: [Fetches homepage video data]
 */

import {
  MediaVariant,
  Variant,
} from "@components/Layouts/HomePageStoryPackages/MediaPackages/types/MediaVariant.d";
import fetchBHApi from "@helper/fetchBHApi";
import { LatestVideoResponse } from "@hooks/transformer/useBrightcoveResponse";
import { PlaylistType } from "@typings/Playlist.d";
import { useEffect, useState } from "react";

type useHomePageVideoData = {
  videos: LatestVideoResponse[];
};

type useHomePageVideoProps = {
  variant?: Variant;
};

/**
 * Custom React Hook: useHomePageVideoHook
 * Description: [Fetches homepage video data]
 * @param props - The props required by the hook (if any)
 * @returns data - The data returned by the hook
 */
export default function useHomePageVideo({
  variant = MediaVariant.VIDEOS,
}: useHomePageVideoProps): useHomePageVideoData {
  const [videos, setVideos] = useState<LatestVideoResponse[]>([]);
  const videoApiUrl =
    variant === MediaVariant.RINGKAS
      ? `latest-videos-playlist?playlistId=${PlaylistType.PORTRAIT_VIDEO}&size=10&offset=0`
      : "latest-videos";

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      try {
        const response = await fetchBHApi<LatestVideoResponse[]>(
          videoApiUrl,
          "GET",
        );

        if (!cancelled) {
          setVideos(response);
        }
      } catch (error) {
        console.error(
          `Brightcove videos: ${videoApiUrl} could not be fetched`,
          error,
        );
      }
    };

    void fetchData();

    return () => {
      cancelled = true;
    };
  }, [videoApiUrl]);

  return { videos };
}
